<template>
  <el-card class="page-container">
    <h1 class="title-biaoti">主播收入明细报表</h1>
    <el-row :gutter="20" class="user-options">
      <el-col :span="5">
        <span>数据日期</span>
        <el-date-picker
          v-model="platformData"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="5">
        <span>转正日期</span>
        <el-date-picker
          v-model="platformData1"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="retainedOptions"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="3">
        <span>国家</span>
        <el-select
          filterable
          style="width: 160px"
          v-model="country"
          placeholder=""
        >
          <el-option
            v-for="(item, itemIndex) in countryList"
            v-bind:key="itemIndex + 99"
            :label="item.country"
            :value="item.countryCode"
          ></el-option>
        </el-select>
      </el-col>
      <el-col :span="2">
        <el-input v-model="rid" placeholder="主播id 选填"></el-input>
      </el-col>
      <el-col :span="2">
        <el-input v-model="agentId" placeholder="代理id 选填"></el-input>
      </el-col>
      <el-col :span="6">
        <el-button type="warning" @click="getDayChatDetai(0)" :loading="login1">
          查询
        </el-button>

        <el-button type="success" @click="dwnDayChatDetai" :loading="login2">
          下载
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="3">
        <el-date-picker
          v-model="demotionDay"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        >
        </el-date-picker>
      </el-col>
      <el-col :span="6">
        <el-button
          type="warning"
          @click="getDayChatDetai_(0)"
          :loading="login1"
        >
          降级列表查询
        </el-button>
        <el-button type="success" @click="dwnDayChatDetai_" :loading="login2">
          降级列表下载
        </el-button>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="4">
        <el-date-picker
          value-format="yyyy-MM-dd"
          v-model="time"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker
      ></el-col>
      <el-col :span="4">
        <el-time-picker
          is-range
          v-model="times"
          value-format="HH"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker>
      </el-col>
      <el-col :span="6">
        <el-button type="success" :loading="login2" @click="dwnDayChatDetai_s">
          定时数据接口导出
        </el-button>
      </el-col>
    </el-row>
    <el-row class="user-options">
      <el-table
        :data="dayChatDetailData"
        style="width: 100%"
        v-loading="login1"
        height="80vh"
        stripe
        border
      >
        <el-table-column
          prop="date"
          label="数据日期"
          width="180"
          fixed="left"
        />
        <el-table-column prop="rid" label="主播id" width="180">
          <template slot-scope="scope">
            <el-popover placement="right" width="420" trigger="click">
              <div style="height: 400px; overflow-y: scroll">
                <el-table :data="list_ta">
                  <el-table-column
                    property="cid"
                    label="通话id"
                  ></el-table-column>
                  <el-table-column
                    property="userRid"
                    label="用户id"
                  ></el-table-column>
                  <el-table-column
                    property="connectTime"
                    label="通话时长"
                  ></el-table-column>
                  <el-table-column
                    property="startTime"
                    label="通话开始时间"
                  ></el-table-column>
                  <el-table-column
                    property="userCountry"
                    label="用户国家"
                  ></el-table-column>
                </el-table>
              </div>
              <span
                @click="chat(scope.row.rid, scope.row.date)"
                slot="reference"
                >{{ scope.row.rid }}</span
              >
            </el-popover>
          </template>
        </el-table-column>
        <el-table-column label="基本信息" align="center" class-name="aaa">
          <el-table-column prop="registerDate" label="注册日期" width="180" />
          <el-table-column prop="positiveDate" label="转正日期" width="180" />
          <el-table-column prop="country" label="国家" width="180" />
          <el-table-column prop="language" label="语言" width="180" />
          <el-table-column prop="agentName" label="代理名" width="180" />
          <el-table-column prop="isNewHost" label="新老主播" width="180">
            <template slot-scope="scope">
              {{ scope.row.isNewHost ? '新主播' : '老主播' }}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="流量收入" align="center">
          <el-table-column prop="appraiseScore" label="评分等级" width="180" />
          <el-table-column prop="online" label="在线时长-min" width="180" />
          <el-table-column
            prop="totalPopularCount"
            label="总曝光"
            width="180"
          />
          <el-table-column prop="popularUser" label="曝光总人数" width="180" />
          <el-table-column
            prop="sameCountryPopularCount"
            label="区域匹配有效曝光次数"
            width="180"
          />
          <el-table-column
            prop="sameCountryPopularUser"
            label="区域匹配有效曝光人数"
            width="180"
          />
          <el-table-column
            prop="totalCallCount"
            label="总拨打次数"
            width="180"
          />

          <el-table-column
            prop="totalConnectCount"
            label="总接通次数"
            width="180"
          />
          <el-table-column
            prop="totalCallDuration"
            label="主播单日总通话时长"
            width="180"
          />
          <el-table-column
            prop="avgCallDuration"
            label="平均单通通话时长"
            width="180"
          />

          <el-table-column prop="totalCallRate" label="总拨打率" width="180" />

          <el-table-column
            prop="effectivePopularCount"
            label="有效曝光次数"
            width="180"
          />
          <el-table-column
            prop="effectivePopularUser"
            label="有效曝光人数"
            width="180"
          />
          <el-table-column
            prop="effectiveCallCount"
            label="有效拨打次数"
            width="180"
          />
          <el-table-column
            prop="effectiveCallRate"
            label="有效拨打率"
            width="180"
          />
          <el-table-column
            prop="effectiveCallConnectRate"
            label="有效拨打接通率"
            width="180"
          />
          <el-table-column prop="callIncome" label="通话收入-USD" width="180" />
          <!-- <el-table-column prop="matchCount" label="抢单通话次数" width="180" /> -->
          <el-table-column
            prop="matchIncome"
            label="抢单通话-USD"
            width="180"
          />
          <el-table-column prop="giftIncome" label="礼物收入-USD" width="180" />
          <el-table-column prop="giftRate" label="礼物占比" width="180" />
          <el-table-column
            prop="flowIncome"
            label="流量总收入-USD"
            width="180"
          />
        </el-table-column>
        <el-table-column label="保收情况" align="center">
          <!-- <el-table-column prop="needGuarantee" label="需保收金额-USD" width="180" /> -->
          <!-- <el-table-column prop="actualGuarantee" label="实际保收金额-USD" width="180" /> -->
          <!-- <el-table-column prop="dGuarantee" label="差额-USD" width="180" /> -->
          <!-- <el-table-column prop="guaranteeCallCount" label="保收通话量" width="180" /> -->

          <!-- <el-table-column prop="uacCount" label="UAC电话量" width="180" /> -->
          <!-- <el-table-column prop="downloadCount" label="下载电话量" width="180" /> -->
          <!-- 添加 -->
          <el-table-column
            prop="matchTotalIncome"
            label="匹配通话总收入"
            width="180"
          />
          <el-table-column
            prop="matchTotalIncomeUSD"
            label="匹配通话总收入-USD"
            width="180"
          />

          <el-table-column
            prop="guaranteeCallRate"
            label="接通率"
            width="180"
          />
          <!-- <el-table-column prop="greatMatchCount" label="优质匹配通话次数" width="180" /> -->
          <!-- <el-table-column prop="greatMatchIncome" label="优质匹配通话收入--USD" width="180" /> -->
          <!-- <el-table-column prop="greatMatchRate" label="优质匹配通话率" width="180" /> -->
          <!-- 添加 -->
          <el-table-column
            prop="matchCallCount"
            label="匹配通话次数"
            width="180"
          />
          <el-table-column
            prop="matchCallUserCount"
            label="匹配通话人数"
            width="180"
          />
          <el-table-column
            prop="matchIncome"
            label="匹配通话收入"
            width="180"
          />

          <!-- <el-table-column prop="guaranteeCallIncome" label="保收通话收入-USD" width="180" /> -->
          <!-- 添加 -->
          <el-table-column
            prop="activeMatchCallCount"
            label="有余额匹配次数"
            width="180"
          />
          <el-table-column
            prop="activeMatchCallUserCount"
            label="有余额匹配人数"
            width="180"
          />
          <el-table-column
            prop="activeMatchIncome"
            label="有余额匹配收入"
            width="180"
          />

          <el-table-column
            prop="less20sMatchCallIncome"
            label="纯匹配通话收入"
            width="180"
          />
          <el-table-column
            prop="extend20sMatchCallIncome"
            label="超过20s匹配通话收入"
            width="180"
          />
          <el-table-column
            prop="less20sMatchCallIncomeRate"
            label="纯匹配通话收入占比"
            width="180"
          />
          <el-table-column
            prop="extend20sMatchCallIncomeRate"
            label="超过20s匹配通话收入占比"
            width="180"
          />

          <!-- <el-table-column prop="matchGuaranteeTimes" label="接通保收匹配卡次数" width="180" /> -->
          <!-- <el-table-column prop="matchTaskIncome" label="匹配卡任务收入-USD" width="180" /> -->
          <el-table-column prop="taskIncome" label="任务收入-USD" width="180" />
          <el-table-column prop="totalIncome" label="总收入-USD" width="180" />
          <el-table-column
            prop="guaranteeIncomeRate"
            label="匹配收入占比"
            width="180"
          />
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="user-options">
      <el-pagination
        :current-page.sync="page"
        layout="total, prev, pager, next"
        background
        @current-change="handleCurrentChange"
        :total="total"
        :page-size="30"
      ></el-pagination>
    </el-row>
  </el-card>
</template>

<script>
import download from '@/utils/download.js'
import { getCountry, getLanguage } from '@/utils/normalApi.js'
import { mapState } from 'vuex'
import { datainfor } from '@/utils/formdata.js'
export default {
  data() {
    return {
      time: '',
      times: ['', ''],

      page_: false,
      demotionDay: datainfor(1),
      demotionDay_: datainfor(1),
      type: 1,
      types: [
        {
          label: '0:00:00-06:00 UTC',
          value: 1,
        },
        {
          label: '07:00-14:00 UTC',
          value: 2,
        },
      ],
      // 加载
      login1: false,
      login2: false,
      // 用户id白名单 MultipartFile文件
      ridFile: '',
      // 代理名或者代理id
      agentName: '',
      // 通话日期
      platformData: [datainfor(1), datainfor(1)],
      platformData1: null,
      retainedOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        shortcuts: [
          {
            text: '最一周',
            onClick(picker) {
              picker.$emit('pick', [datainfor(8), datainfor(1)])
            },
          },
        ],
      },
      // 分引
      page: 1,
      total: 0,
      // 表格数据
      dayChatDetailData: [],

      country: 'total',
      countryList: [],
      agentId: '',
      rid: '',
      agentId: '',
      language: 'all',
      languageList: [],
      assRating: '',
      score: '',
      labelId: 0,
      list_ta: [],
      visible: false,
    }
  },
  computed: {
    ...mapState(['faceValueList']),
  },
  async created() {
    await this._getLanguage()
    this.getDayChatDetai()
    this._getCountry()
  },
  methods: {
    async _getCountry() {
      const res = await getCountry()
      if (res !== null) {
        this.countryList = res.countryList
      }
    },
    async _getLanguage() {
      const res = await getLanguage()
      if (res !== null) {
        this.languageList = res
        this.language = res[0].langCode
      }
    },
    // 查询列表
    async getDayChatDetai(num) {
      this.login1 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      if (num == 0) {
        this.page = 1
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.income_detail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          positiveStart: this.platformData1[0],
          positiveEnd: this.platformData1[1],
          page: this.page,
          country: this.country,
          rid: this.rid,
          agentId: this.agentId,
        },
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      let newList = []
      res.data.data.map((e, i) => {
        newList.push({ index: i + 1 + (this.page - 1) * 10, ...e })
      })
      this.page_ = true
      this.dayChatDetailData = newList
      this.total = res.data.total
    },
    async getDayChatDetai_(num) {
      this.login1 = true
      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      if (num == 0) {
        this.page = 1
      }
      const { data: res } = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.income_detail,
        withCredentials: true,
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          demotionDay: this.demotionDay,
          start: this.platformData[0],
          end: this.platformData[1],
          positiveStart: this.platformData1[0],
          positiveEnd: this.platformData1[1],
          page: this.page,
          searchType: 1,
          country: this.country,
          rid: this.rid,
        },
      })
      this.login1 = false
      if (res.code != 0) return this.$message(res.msg)
      let newList = []
      res.data.data.map((e, i) => {
        newList.push({ index: i + 1 + (this.page - 1) * 10, ...e })
      })
      this.page_ = false
      this.dayChatDetailData = newList
      this.total = res.data.total
    },
    // 通话明细
    async chat(num, date) {
      const { data: res } = await this.$axios(
        this.$store.getters.path.income_chat_detail,
        {
          params: {
            rid: num,
            date: date,
            username: this.$store.getters.username,
            token: this.$store.getters.token,
          },
        }
      )
      this.list_ta = res.data.data
    },
    // 下载
    async dwnDayChatDetai() {
      this.login2 = true

      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.income_detail_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          start: this.platformData[0],
          end: this.platformData[1],
          positiveStart: this.platformData1[0],
          positiveEnd: this.platformData1[1],
          country: this.country,
          rid: this.rid,
          agentId: this.agentId,
        },
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '主播收入明细报表' + this.platformData[1])
    },
    async dwnDayChatDetai_() {
      this.login2 = true

      if (this.platformData == null) {
        this.platformData = ['', '']
      }
      if (this.platformData1 == null) {
        this.platformData1 = ['', '']
      }
      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.income_detail_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          demotionDay: this.demotionDay,
          start: this.platformData[0],
          end: this.platformData[1],
          positiveStart: this.platformData1[0],
          positiveEnd: this.platformData1[1],
          country: this.country,
          searchType: 1,
          rid: this.rid,
        },
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '降级名单报表' + this.platformData[1])
    },
    async dwnDayChatDetai_s() {
      this.login2 = true

      const res = await this.$axios({
        method: 'get',
        url: this.$store.getters.path.income_chat_download,
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
        },
        responseType: 'blob',
        params: {
          username: this.$store.getters.username,
          token: this.$store.getters.token,
          date: this.time,
          startHourTime: this.times[0] + ':00:00',
          endHourTime: this.times[1] + ':00:00',
        },
      })

      this.$message.success('开始下载')
      this.login2 = false
      download(res.data, '定时数据' + this.time)
    },

    // 分页
    handleCurrentChange() {
      if (this.page_) {
        this.getDayChatDetai()
      } else {
        this.getDayChatDetai_()
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
@import '../../assets/stylus/variable.styl';

.page-container {
  margin-left: 20px;
  margin-top: 20px;

  .el-col {
    display: flex;
    align-items: center;

    >div {
      margin-right: 5px;
    }
  }

  h1 {
    font-size: 28px;
    font-weight: bold;
  }

  .user-options {
    margin-top: 40px;

    button {
      margin-left: 30px;
    }

    .el-col {
        margin-bottom: 20px
    }
  }

  .display-type {
    margin-top: 20px;

    .line {
      width: 1440px;
      height: 700px;
    }
  }

}
</style>
